import { useTranslation } from 'react-i18next';
import {
  ReportModalContainer,
  ReportModalContainerProps,
} from './ReportModalContainer';

type CommentReportModalProps = Omit<
  ReportModalContainerProps,
  'title' | 'description' | 'getConfirmationText' | 'initialReportCategoryId'
>;

export const CommentReportModal = (props: CommentReportModalProps) => {
  const { t } = useTranslation('components.event', { useSuspense: false });

  return (
    <ReportModalContainer
      {...props}
      title={t('report-comment-modal.title')!}
      description={t('report-comment-modal.description')!}
      getConfirmationText={(flag) =>
        t('report-comment-modal.confirmation-text', { flag })
      }
      initialReportCategoryId="comment_flag_categories"
    />
  );
};
